export default "__VITE_ASSET__BAV83Iny__"